export const MOBILE_BREAKPOINT = 767;
export const TABLET_BREAKPOINT = 991;
export const URGENCY_DESTINATION_MESSAGE_TYPE = [
    'ICON_TITLE_TEXT',
    'ICON_TEXT',
];

export const LAZY_LOAD_OFFSET = {
    DEFAULT: 100,
    MOBILE: 66,
};

export const TEMPLATE_ID_HEADER = 'x-ha-landingapp-template_id';
export const BOT_HEADER = 'x-ha-landingapp-is_bot';

export const RECOMMENDATION_SERVICE_PROPERTY_TARGET = {
    SLP: 'SLP_SIMILAR_PROPERTY',
    MLP: 'MLP_SIMILAR_PROPERTY',
};

export const RECOMMENDATION_SERVICE_DESTINATION_TARGET = {
    SLP: 'SLP_SIMILAR_DESTINATION',
    MLP: 'MLP_SIMILAR_DESTINATION',
};

export const HIGH_LEVEL_GEOTYPES = {
    CONTINENT: 'continent',
    COUNTRY: 'country',
    ADMINISTRATIVE_DIVISION_LEVEL_1: 'administrative_division_level_1',
    ADMINISTRATIVE_DIVISION_LEVEL_2: 'administrative_division_level_2',
    ADMINISTRATIVE_DIVISION_LEVEL_3: 'administrative_division_level_3',
    ADMINISTRATIVE_DIVISION_LEVEL_4: 'administrative_division_level_4',
    ADMINISTRATIVE_DIVISION_LEVEL_5: 'administrative_division_level_5',
    NATURAL_FEATURE: 'natural_feature',
    TOURISTIC_REGION: 'touristic_region',
    LOCALITY: 'locality',
};

export const LOW_LEVEL_GEOTYPES = {
    SUBLOCALITY_LEVEL_1: 'sublocality_level_1',
    SUBLOCALITY_LEVEL_2: 'sublocality_level_2',
    SUBLOCALITY_LEVEL_3: 'sublocality_level_3',
    SUBLOCALITY_LEVEL_4: 'sublocality_level_4',
    SUBLOCALITY_LEVEL_5: 'sublocality_level_5',
    BEACH: 'beach',
    ISLAND: 'island',
    SKI_AREA: 'ski_area',
    NEIGHBORHOOD: 'neighborhood',
    PARK: 'park',
    POINT_OF_INTEREST: 'point_of_interest',
    PREMISES: 'premises',
    TRAIN_STATION: 'train_station',
    METRO_STATION: 'metro_station',
    AIRPORT: 'airport',
    POSTAL_CODE: 'postal_code',
    EVENT: 'event',
};

export const MAP_CONFIG = {
    apiKey: 'AIzaSyC_acVe8fX96_NJF0lVA0V44kVKBznXL_M',
    channel: 'vrbo-slp',
};

// module status
export const PENDING = 'PENDING';
export const HIDDEN = 'HIDDEN';
export const LOADED = 'LOADED';

// modules
export const SEO_ACCORDION = 'seo-accordion';
export const REVIEWS = 'reviews';
export const VALUE_PROPS = 'value-props';

// RUM solutions
export const RUM = {
    SENTRY: 'sentry',
    NONE: 'none',
    DATADOG: 'datadog',
};

export const treatments = {
    C9: {
        width: 360,
        height: 270,
    },
};

// Resize Image
export const resizeImg = (treatment) => {
    return Object.entries(treatments).map(([key, {width, height}]) => {
        if (key === treatment) return `?impolicy=fcrop&w=${width}&h=${height}`;
        return '';
    })[0];
};
